
/**
 * Take an object of array of errors for each attribute.
 * Before showing the new errors all old error will be removed.
 *
 * Exemple: {card_number: ['Card number is required', 'An other error on card number'], login: ['error on login field']}
 */
window.showFormErrors = function(formErrors)
{
	clearError();

	for(const key in formErrors)
	{
		let inputErrors = formErrors[key];
		const name = convertToInputName(key);

		const field = $('[name="' + name + '"]');

		if ( !Array.isArray(inputErrors) )
		{
			inputErrors = [inputErrors];
		}

		if (field.length === 0)
		{
			addFlashAlert('danger', inputErrors.map(htmlEncode).join('<br />'));
		}
		else
		{
			for (const error of inputErrors)
			{
				addFieldError(field, error);
			}
		}
	}
};

window.keepErrors = false;
/**
 * Remove all error message on field and flash message
 */
window.clearError = function()
{
	if (window.keepErrors)
	{
		return;
	}
	cleanFlashAlert();

	$('input').each(
		function(index, field)
		{
			clearFieldError($(field));
		}
	);
};


function addFieldError(field, message)
{
	field
		.addClass('is-danger') // Add .is-danger to input
		.parent('.control')
		.addClass('is-danger') // Add .is-danger to .control (needed if .around-input)
		.nextAll('.is-error-message') // Find the last error message
		.addBack() // or the .control its self
		.last() // needed to preserve error message order
		.after('<p class="help is-danger is-error-message">' + message + '</p>')
	;
}

function clearFieldError(field)
{
	field
		.removeClass('is-danger') // Remove .is-danger to input
		.parent('.control')
		.removeClass('is-danger') // Remove .is-danger to .control (needed if .around-input)
		.nextAll('.is-error-message')
		.remove() // Remove all error messages
	;
}

function convertToInputName(key)
{
	var array = key.split('.');

	if (array.length <= 1)
	{
		return key;
	}

	var first = array.shift();

	return first + '[' + array.join('][') + ']';
}
